import { CustomerReview } from "../Reviews/customerWorkflow";
export type Jurisdiction =
  | { level: "unsure" }
  | { level: "country" | "federal"; countryCode: string }
  | { level: "state_region"; countryCode: string; region: string };
export type Question = {
  id: string;
  title: string;
  topicKey: string;
  jurisdiction: Jurisdiction;
  questionText: string;
  status: "draft" | "active" | "archived";
  workproductId?: string | null;
  version: number;
  createdAt: string;
  updatedAt: string;
  lastActivityAt?: string;
  reviews?: (CustomerReview & {
    id: string;
    status: string;
    proposal_state?: string;
    closed_at?: string;
    created_at: string;
    updated_at: string;
    due_at?: string;
    completed_at?: string;
    attorney_name: string | null;
    needs_reply: boolean;
    needs_action?: boolean;
    version?: number;
    /** The card saved for this review, if any (brand and last four only). */
    card?: { brand: string; last4: string } | null;
  })[];
};
export type Intake = Pick<Question, "title" | "topicKey" | "jurisdiction">;
export type Topic = { id: string; label: string };
const base = process.env.REACT_APP_BACKEND_URL || "http://localhost:3201";
export async function questionApi<T>(
  path: string,
  method = "GET",
  body?: unknown,
  signal?: AbortSignal
): Promise<T> {
  const response = await fetch(`${base}/api/questions${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok)
    throw Object.assign(
      new Error(
        data.message || "Could not complete this request. Please try again."
      ),
      { status: response.status }
    );
  return data;
}
export function describeJurisdiction(value: Jurisdiction): string {
  if (value.level === "unsure") return "Location not set";
  if (value.level === "state_region")
    return `${value.region}, ${value.countryCode}`;
  return value.level === "federal"
    ? `${value.countryCode} (federal)`
    : value.countryCode;
}
